import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/eventDate'
export const namespace = 'eventDate'
export const clientRoute = '/event/date'
export const dependencies = ['event']
export const params = {
  include: 'event'
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'startDate'
const subtitleColumn = 'endDate'
const infoColumns = ['isAllDay', 'shortDescription']
/* --------------------------- */

const state = {
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
